/**
 * @desc: - 单个赛马
 */
import React from 'react';
import ReactDOM from 'react-dom'
export default class Horse extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      position: null
    }
    // 名次对应的位置值，共10个
    this.rankPos = [680, 620, 550, 440 ,420, 410, 390, 350, 310, 210]
  }

  componentDidMount(){
    window.setTimeout(()=>this.randomRank(), 500)
  }

  shouldComponentUpdate(nextProps, nextState){
    if (nextProps.rank == this.props.rank && nextState.position == this.state.position) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    if (this.nextTimer) {window.clearTimeout(this.nextTimer)}
    if (this.endTimer) {window.clearTimeout(this.endTimer)}
  }

   // 开奖后结束跑马
  componentWillReceiveProps(nextProps) {
    const { rank } = this.props;
    const _rank = nextProps.rank;
    // 之前是空，现在有值
    if (rank == -1 && _rank != -1 ) {
      this.stopRunning(_rank);
    }
  }

  // 停止跑马
  stopRunning(rank){
    if (this.nextTimer) {window.clearTimeout(this.nextTimer)}
    const pos = this.rankPos[rank];
    this.setState({
      position: pos + 'px'
    })
    // 2秒后调整到最终撞线状态
    this.endTimer = window.setTimeout(function(){
      this.setState({
        position: 1000 + pos + 'px'
      })
    }.bind(this), 2000)  
  }

  // 开始随机运动
  randomRank(){
    // 下一次调整间隔
    const nextModify = _.random(1000, 3000);
    // 当前位置取值范围
    const currentPosition = _.random(200, 600)
    this.setState({
      position: currentPosition + 'px'
    })
    // 去下一次调整
    this.nextTimer = window.setTimeout(this.randomRank.bind(this), nextModify);
  }

  render() {
    const { no } = this.props;
    return (
      <div className={'horse-am run no' + no} style={{left: this.state.position || '0px'}}></div>
    );
  }
}